import { DRIVER_VS_COSTS_DATA_FETCHED, RESET_DRIVER_VS_COSTS, APPLY_SEARCH_ON_DRIVER_VS_COSTS, CLEAR_SEARCH_ON_DRIVER_VS_COSTS } from "../actions/scoreOverview"

let driverVsCostsState = {
  loading: false,
  data: [],
  date: {},
  fullDriverList: []
}
let filteredData=[];

export default (state = driverVsCostsState, action = {}) => {
  switch (action.type) {
    case DRIVER_VS_COSTS_DATA_FETCHED:
      return {
        ...state,
        date: action.payload.date,
        data: action.payload.data,
        fullDriverList: action.payload.data
      };
    case RESET_DRIVER_VS_COSTS:
      return {
        ...driverVsCostsState
      };
    case APPLY_SEARCH_ON_DRIVER_VS_COSTS:
      filteredData = state?.fullDriverList?.filter((driver) => driver.driversFirstName.toLowerCase().includes(action.payload.toLowerCase()) || driver.driversSurName.toLowerCase().includes(action.payload.toLowerCase()))
      if (!filteredData) {
        return {
          ...state,
          data:[]
        }
      }
      return {
        ...state,
        data: [...filteredData]
      }
    case CLEAR_SEARCH_ON_DRIVER_VS_COSTS:
      return {
        ...state,
        data: [...state.fullDriverList]
      }
    default:
      return state;
  }
};